import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { FilePondFile, FilePondOptions } from 'filepond';
import { useQueryClient } from 'vue-query';
import { debounce } from 'lodash';
import { nextTick, onMounted, ref, PropType, onBeforeUnmount } from 'vue';

import { api } from '@/services';

import { VoltaMeasure } from '@/entities/volta-measure/types';

import { voltaMeasuresQueryName } from '@/entities/volta-measure/hooks';
import { NkFilePond } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'VoltaMeasureFileDropZone',
  props: {
  voltaMeasure: {
    type: Number as PropType<VoltaMeasure['id']>,
    default: null,
  },
  options: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['submitted', 'failure', 'add-file', 'remove-file'],
  setup(__props, { expose, emit }) {

const props = __props





const fileDropzone = ref<typeof NkFilePond>();
const queryClient = useQueryClient();
const fileUploadErrorTimer: any = ref(null);
const fileUploadSuccessTimer: any = ref(null);

const handleFileUpload = debounce(() => {
  const files: FilePondFile[] = fileDropzone.value?.filePond.getFiles();

  const formData = new FormData();

  if (files && files.length) {
    files.map(o => o.file).forEach(o => formData.append('files[]', o));

    api.post(`/volta_measures/${ props.voltaMeasure }/upload`, formData)
      .then(() => {
        emit('submitted');
        fileUploadSuccessTimer.value = setTimeout(() => {
          fileUploadSuccessTimer.value = null;
        }, 7000);
        queryClient.refetchQueries([voltaMeasuresQueryName, { id: props.voltaMeasure }], {active: true});
      })
      .catch((e) => {
        fileUploadErrorTimer.value = setTimeout(() => {
          fileUploadErrorTimer.value = null;
        }, 7000);
        emit('failure');
      })
      .finally(() => {
          fileDropzone.value?.filePond.removeFiles();
        },
      );
  }
}, 200);

onMounted(() => {
  nextTick(() => {
    if (props.voltaMeasure) {
      fileDropzone.value?.filePond._pond.setOptions({
        server: {
          process: handleFileUpload,
        },
      } as FilePondOptions);
    } else {
      fileDropzone.value?.filePond._pond.on('addfile', (e, file) => {
        emit('add-file', file);
      });
      fileDropzone.value?.filePond._pond.on('removefile', (e, file) => {
        emit('remove-file', file);
      });
    }
  });
});

onBeforeUnmount(() => {
  fileUploadErrorTimer.value = null;
  fileUploadSuccessTimer.value = null;
});

expose({
  fileDropzone,
})

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (fileUploadErrorTimer.value)
      ? (_openBlock(), _createBlock(_component_ElAlert, {
          key: 0,
          "show-icon": "",
          type: "error",
          title: _ctx.$t('notification.error')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (fileUploadSuccessTimer.value)
      ? (_openBlock(), _createBlock(_component_ElAlert, {
          key: 1,
          "show-icon": "",
          type: "success",
          title: _ctx.$t('notification.file_upload_success')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(NkFilePond), _mergeProps({
      class: "mt-2",
      ref_key: "fileDropzone",
      ref: fileDropzone,
      options: {
        allowImagePreview: true,
        immediate: false,
        allowMultiple: false,
        ...props.options,
      },
      "accepted-file-types": "image/jpeg, image/png"
    }, _ctx.$attrs), null, 16, ["options"])
  ]))
}
}

})